<fs-drag-bar
  id="dragBar"
  [header]="header"
  [secondaryActions]="minMaxBtns"
  [tertiaryActions]="extraActionBtns"
  (closeDialog)="this.close()"
>
  <div class="chat-header">
    <h2 mat-dialog-title>
      <div class="channelName" *ngIf="activeChannel">
        <span class="title">
          {{ activeChannel.name }}
        </span>
      </div>
    </h2>
  </div>
  <mat-dialog-content *ngIf="chatLoaded$ | async; else chatLoading">
    <div class="loadingChannelContainer" *ngIf="isLoading && !activeChannel">
      <mat-spinner diameter="42" mode="indeterminate" color="accent"></mat-spinner>
      <span class="loading-text-spacing">{{ 'map.tools.chatDrawer.loadingChannel' | t }}...</span>
    </div>
    <sn-chat-channel-list
      *ngIf="!activeChannel && !isLoading"
      (channelSelected)="selectChannel($event)"
    ></sn-chat-channel-list>
    <div *ngIf="activeChannel && !isLoading">
      <ng-container *ngIf="userHasAccess; else joinTmpl">
        <sn-message-list *ngIf="activeChannel.twilioChannel" [channel]="activeChannel">
        </sn-message-list>
      </ng-container>
      <ng-template #joinTmpl>
        <div class="join-container">
          <h3>{{ 'map.tools.chatDrawer.notJoinedMessage' | t }}</h3>
          <br /><br />
          <button mat-button color="success" (click)="join()">{{ 'map.tools.chatDrawer.joinChannel' | t }}</button>
        </div>
      </ng-template>
    </div>
  </mat-dialog-content>
  <ng-template #chatLoading>
    <div class="drawer-loader">
      <mat-progress-spinner color="accent" diameter="48" mode="indeterminate">
      </mat-progress-spinner>
    </div>
  </ng-template>

  <mat-dialog-actions>
    <sn-new-message
      *ngIf="activeChannel?.twilioChannel"
      class="chat"
      [channel]="activeChannel"
    ></sn-new-message>
  </mat-dialog-actions>
</fs-drag-bar>
